/* eslint-disable no-use-before-define */
import React from 'react'
import { getState, ajax, Status, show } from '../../twd'

const Last = getState('overview.quick-ideas', {})

export default ({ id, url, params, rowCount=1 }) => {
    const hasLast = (id in Last.value)
    const initStatus = hasLast ? Status.LOADED : Status.LOADING
    const initData = hasLast ? Last.value[id] : []

    const [status, setStatus] = React.useState(initStatus)
    const [data, setData] = React.useState(initData)
    const lastAbort = React.useRef()

    React.useEffect(() => {

        if (status!==Status.LOADING) return

        ;(async () => {
            try {
                let {data, abort} = await ajax({
                    url: url,
                    method: 'POST',
                    params: params
                })

                lastAbort.current = abort
                let a = await data
                lastAbort.current = null

                let rs = getRows(a, rowCount)
                Last.set({ [id]:rs })
                setData(rs)

                setStatus(Status.LOADED)
            } catch(e) {
                if (e.name==='AbortError') {
                    return
                }

                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

        return () => {
            if (lastAbort.current) lastAbort.current()
        }
    }, [status])

    return { status, Status, setStatus, data, onViewAll }
}

export const onViewAll = ({searchParams}) => {
    if (!searchParams) return
    show('offerings', Object.assign({
        searchParams,
        _ts: Date.now(),
        from: 'overview'
    }))
}

const getRows = ({quickIdeasDto={}}, rowCount) => {
    let m = Object.values(quickIdeasDto|| {})[0]
    return Object.values(m)
        .filter(Boolean)
        .map((v) => {
            return (v.rowsList || v.rows || []).slice(0,rowCount)
        })
        .flat()
        .filter(Boolean)
}



// WEBPACK FOOTER //
// ./src/overview/quick-ideas/use-quick-ideas.js